import { IState } from '../store';

export const selectSpecialPromoInfo = (state: IState) => {
  return state.specialPromoInfo;
};
